<template>
  <div>
    <Modal :visible="visible" @ok="$emit('ok')" @cancel="$emit('cancel')" class="h-5/6">
      <div>
        <div class="tx-1">ログインして、お気に入りに</div>
        <div class="tx-2">メニューを保存しましょう。</div>
        <div class="btnd"><a-button class="btn1" @click="handleLogin"><span>ログイン</span></a-button></div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { Modal } from '@/components/primitive'

export default {
  components: {
    Modal
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      
    }
  },
  methods: {
    handleLogin() {
      // const continueUri = encodeURIComponent(`${location.protocol}//${location.host}/demo`)
      // const href = `${process.env.VUE_APP_BASE_URL}/login?continuous=${continueUri}`
      // location.href = href
      // window.location = (`https://tst-auth.benefit-test.jp/auth/login?callback_authorization_start_uri=${process.env.VUE_APP_BASE_URL}/auth-start`)
      this.setCurrentHref()
      window.location = (`${process.env.VUE_APP_API_URL}/v1/stay/login`)
    }
  }
}
</script>
<style lang="scss" scoped>
  @import './style.scss';
</style>